/*
import state from "./state"
import mutations from "./mutations"
import actions from "./actions"
import getters from "./getters"

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
*/

import { Module } from "vuex-smart-module"

import GruposState from "./state"
import GruposMutations from "./mutations"
import GruposGetters from "./getters"
import GruposActions from "./actions"

export const gruposModule = new Module({
  state: GruposState,
  getters: GruposGetters,
  mutations: GruposMutations,
  actions: GruposActions,
})
